import { useMutation, useQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import View from "./View";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.FEEDS.LIST);
  const [updateFeed] = useMutation(graphql.mutations.UPDATE_FEED, {
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.FEEDS.LIST);
    },
    onError: () => {},
  });
  const { data, loading, error } = useQuery(graphql.queries.FEED, {
    variables: { where: { id } },
  });

  const onSubmit = (data) => {
    return updateFeed({
      variables: {
        where: {
          id,
        },
        data,
      },
    });
  };

  if (loading || error) return "Loading";

  return <View onSubmit={onSubmit} feed={data.feed} cancel={cancel} />;
};

export default Detail;
